export default __webpack_public_path__ + "b75973f40089e4a83024415589377b2a.svg";